(function () {
  'use strict';

  var STORAGE_KEY = 'buy_later_items';
  var LIMIT = 10;
  var ENDPOINTS = {
    add: '/apps/api/buy_later_add',
    remove: '/apps/api/buy_later_remove',
    list: '/apps/api/buy_later_list',
    merge: '/apps/api/buy_later_merge',
  };

  // ページリロード後にも参照できるよう module スコープで保持
  var itemsCache = [];

  // ─── 顧客情報 ────────────────────────────────────────────
  // custom-buy-later-list.liquid の同期インラインスクリプトで設定される
  function isLoggedIn() {
    return !!(window.BUY_LATER_CONFIG && window.BUY_LATER_CONFIG.isLoggedIn);
  }

  function getHmac() {
    return window.BUY_LATER_CONFIG ? window.BUY_LATER_CONFIG.hmac : '';
  }

  function getCustomerId() {
    return window.BUY_LATER_CONFIG ? window.BUY_LATER_CONFIG.customerId : '';
  }

  // ─── LocalStorage (ゲスト) ───────────────────────────────
  function getLocalItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function setLocalItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  // ─── Lambda API (メンバー) ───────────────────────────────
  // 既存 Lambda パターンに合わせ customer_id をボディに含める
  function apiAdd(item) {
    var body = Object.assign({ customer_id: getCustomerId() }, item);
    return fetch(ENDPOINTS.add + '?hmac=' + getHmac(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function apiRemove(addedAt) {
    return fetch(ENDPOINTS.remove + '?hmac=' + getHmac(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: getCustomerId(), added_at: addedAt }),
    }).then(function (r) { return r.json(); });
  }

  function apiList() {
    return fetch(ENDPOINTS.list + '?hmac=' + getHmac() + '&customer_id=' + getCustomerId())
      .then(function (r) { return r.json(); });
  }

  function apiMerge(guestItems) {
    return fetch(ENDPOINTS.merge + '?hmac=' + getHmac(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: getCustomerId(), guest_items: guestItems }),
    }).then(function (r) { return r.json(); });
  }

  // ─── Shopify Cart API ────────────────────────────────────
  function removeFromCart(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }

  function addToCart(variantId, quantity, properties) {
    var body = { id: parseInt(variantId, 10), quantity: quantity };
    if (properties && Object.keys(properties).length > 0) body.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }

  // ─── あとで買うリスト取得 ─────────────────────────────────
  function getItems() {
    if (isLoggedIn()) {
      return apiList()
        .then(function (result) { return result.items || []; })
        .catch(function () { return []; });
    }
    return Promise.resolve(getLocalItems());
  }

  // ─── カウンター更新 ──────────────────────────────────────
  function updateCounter(count) {
    document.querySelectorAll('[data-buy-later-count]').forEach(function (el) {
      el.textContent = count;
    });
    var counterWrap = document.getElementById('buy-later-counter');
    if (counterWrap) counterWrap.hidden = count === 0;
  }

  // ─── リスト描画 ──────────────────────────────────────────
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ─── 表示HTML再構築（ログイン時: APIレスポンスの構造化データから生成） ────
  // custom-cart-item-labels と同じ条件・スタイルで span を生成する
  function buildLabelsHtml(label) {
    if (!label) return '';
    return label.split(',').map(function (l) {
      l = l.trim();
      if (!l) return '';
      return l === 'SALE'
        ? '<span>' + escapeHtml(l) + '</span>'
        : '<span>' + escapeHtml(l) + '</span>';
    }).join('');
  }

  // buy-later-button.liquid の bl_variant_html と同等のロジック
  function buildVariantHtml(option) {
    if (!option || typeof option !== 'object') return '';
    var keys = Object.keys(option);
    if (keys.length === 0) return '';
    var sizeVal = option['サイズ'];
    var colorVal = option['カラー'];
    var hasSize = sizeVal !== undefined && sizeVal !== '';
    var hasColor = colorVal !== undefined && colorVal !== '';
    var html = '';
    if (!hasSize && !hasColor) {
      keys.forEach(function (name) {
        if (option[name] !== '') {
          html += '<p class="cart-item__size">' + escapeHtml(name) + ' ：' + escapeHtml(option[name]) + '</p>';
        }
      });
    } else {
      if (hasSize) {
        html += '<p class="cart-item__size">サイズ ：' + escapeHtml(sizeVal) + '</p>';
      }
      if (hasColor) {
        var colorHandle = String(colorVal).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        html += '<p class="cart-item__color">カラー ：' + escapeHtml(colorVal) + '</span></p>';
      }
    }
    return html;
  }

  // buy-later-button.liquid の bl_properties_html と同等のロジック
  function buildPropertiesHtml(properties) {
    if (!properties || typeof properties !== 'object') return '';
    var inner = Object.keys(properties).filter(function (k) {
      return k !== '_line_item' && k.charAt(0) !== '_';
    }).map(function (k) {
      return escapeHtml(k) + ': ' + escapeHtml(String(properties[k]));
    }).join('<br>');
    return inner ? '<p class="cart-item__properties cart-item__color">' + inner + '</p>' : '';
  }

  function renderItem(item, index, status) {
    var published = !status || status.published !== false;
    var available = published && (!status || status.available !== false);
    var price = '¥' + Math.floor(item.price / 100).toLocaleString('ja-JP');
    var imgHtml = item.image
      ? '<img alt="' + escapeHtml(item.title) + '" src="' + escapeHtml(item.image) + '">'
      : '';
    var itemUrl = item.handle ? '/products/' + item.handle : '#';
    var labelsInner = buildLabelsHtml(item.label);
    var labelsHtml = labelsInner ? '<div class="cart-item__labels">' + labelsInner + '</div>' : '';
    var variantHtml = buildVariantHtml(item.option);
    var propertiesHtml = buildPropertiesHtml(item.properties);
    var statusHtml = !published
      ? '<p class="cart-item__message"><span>この商品は販売を終了しました。</span></p>'
      : !available
        ? '<p class="cart-item__message"><span>こちらの商品は在庫切れ商品です</span></p>'
        : '';
    var buylaterHtml = published
      ? '<div class="cart-item__buylater">' +
          '<button class="underlined-button js-buy-later-to-cart"' +
            ' data-index="' + index + '"' +
            ' type="button">カートに追加する</button>' +
        '</div>'
      : '';

    return (
      '<li class="cart-item">' +
        '<div class="cart-item__image">' +
          '<a href="' + escapeHtml(itemUrl) + '">' + imgHtml + '</a>' +
        '</div>' +
        '<div class="cart-item__body">' +
          labelsHtml +
          '<p class="cart-item__name">' +
            '<a href="' + escapeHtml(itemUrl) + '">' + escapeHtml(item.title) + '</a>' +
          '</p>' +
          variantHtml +
          propertiesHtml +
          '<p class="cart-item__price">' + price + ' <span class="cart-item__tax-in">税込</span></p>' +
          '<p class="cart-item__quantity">数量：' + item.quantity + '</p>' +
          statusHtml +
          '<div class="cart-item__footer">' +
            '<div class="cart-item__action">' +
              buylaterHtml +
              '<div class="cart-item__delete">' +
                '<button class="underlined-button js-buy-later-remove"' +
                  ' data-index="' + index + '"' +
                  ' type="button"><a href="#">削除</a></button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  function bindListEvents(listEl) {
    listEl.querySelectorAll('.js-buy-later-to-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = itemsCache[parseInt(btn.dataset.index, 10)];
        if (!item) return;
        btn.disabled = true;
        moveToCart(item, btn);
      });
    });

    listEl.querySelectorAll('.js-buy-later-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = itemsCache[parseInt(btn.dataset.index, 10)];
        if (!item) return;
        btn.disabled = true;
        removeBuyLaterItem(item.added_at).then(function () {
          return renderList();
        });
      });
    });
  }

  function renderList() {
    var listEl = document.getElementById('buy-later-list');
    var emptyEl = document.getElementById('buy-later-list-empty');
    if (!listEl) return Promise.resolve();

    return getItems().then(function (items) {
      itemsCache = items;
      updateCounter(items.length);

      if (items.length === 0) {
        listEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;

      // 事前在庫チェック（公開状態・在庫を全商品並列取得）
      return Promise.all(items.map(function (item) {
        return fetchProductStatus(item.variant_id, item.handle);
      })).then(function (statuses) {
        listEl.innerHTML = items.map(function (item, i) {
          return renderItem(item, i, statuses[i]);
        }).join('');
        bindListEvents(listEl);
      });
    });
  }

  // ─── あとで買うから削除 ───────────────────────────────────
  function removeBuyLaterItem(addedAt) {
    if (isLoggedIn()) {
      return apiRemove(addedAt).catch(function () {});
    }
    setLocalItems(getLocalItems().filter(function (i) { return i.added_at !== addedAt; }));
    return Promise.resolve();
  }

  // ─── 在庫事前チェック ────────────────────────────────────
  // /cart/add.js はステージング環境等で在庫0でも 200 を返すことがあるため
  // product JSON の variant.available（Shopify が在庫・ポリシーを計算済みの値）で判定する。
  function checkVariantAvailable(variantId, handle) {
    if (!handle) return Promise.resolve(true);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var variants = data.variants || [];
        var vid = parseInt(variantId, 10);
        var v = variants.filter(function (v) { return v.id === vid; })[0];
        if (!v) return true;
        return v.available !== false;
      })
      .catch(function () { return true; });
  }

  // 公開状態（draft は 404）と在庫を同時に取得する。
  // 戻り値: { published: boolean, available: boolean }
  function fetchProductStatus(variantId, handle) {
    if (!handle) return Promise.resolve({ published: true, available: true });
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) return { published: false, available: false };
        return r.json().then(function (data) {
          var variants = data.variants || [];
          var vid = parseInt(variantId, 10);
          var v = variants.filter(function (v) { return v.id === vid; })[0];
          return { published: true, available: v ? v.available !== false : true };
        });
      })
      .catch(function () { return { published: true, available: true }; });
  }

  // ─── 購入上限取得 ─────────────────────────────────────────
  // /products/handle?view=metafields（templates/product.metafields.liquid）から
  // product.metafields.additional.max_qty を取得。未登録なら 9 を返す。
  function fetchMaxQty(handle) {
    if (!handle) return Promise.resolve(9);
    return fetch('/products/' + handle + '?view=metafields')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var val = parseInt(data.max_qty, 10);
        return val > 0 ? val : 9;
      })
      .catch(function () { return 9; });
  }

  // ─── カート現状取得 ─────────────────────────────────────
  function getCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; });
  }

  // ─── アラート表示 ────────────────────────────────────────
  function showBuyLaterMaxAlert() {
    var el = document.querySelector('.js-alert-buy-later-max');
    if (el) el.classList.add('show');
    document.body.classList.add('is-presenting-alert');
  }

  function showBuyLaterOutOfStockAlert() {
    var el = document.querySelector('.js-alert-buy-later-out-of-stock');
    if (el) el.classList.add('show');
    document.body.classList.add('is-presenting-alert');
  }

  function showBuyLaterPurchaseLimitAlert() {
    var el = document.querySelector('.js-alert-buy-later-purchase-limit');
    if (el) el.classList.add('show');
    document.body.classList.add('is-presenting-alert');
  }

  // ─── カートに戻す ────────────────────────────────────────
  // /cart/add.js は環境によって在庫0でも 200 を返すため、
  // 事前に product JSON で在庫確認してから追加する。
  // fetch インターセプターは成否問わず setTimeout(reload, 0) をスケジュールするため
  // ログイン時の apiRemove はリロード前に完了しない。成功時はゲストは同期的に
  // localStorage を更新し、ログインは sessionStorage にフラグを立て
  // リロード後の init で削除を完了させる。
  function moveToCart(item, btn) {
    Promise.all([
      checkVariantAvailable(item.variant_id, item.handle),
      fetchMaxQty(item.handle),
      getCart(),
    ]).then(function (results) {
        var available = results[0];
        var maxQty    = results[1];
        var cart      = results[2];

        if (!available) {
          showBuyLaterOutOfStockAlert();
          if (btn) btn.disabled = false;
          return;
        }

        var cartItem = (cart.items || []).filter(function (i) {
          return i.variant_id == item.variant_id;
        })[0];
        var cartQty = cartItem ? cartItem.quantity : 0;
        if (cartQty + item.quantity > maxQty) {
          showBuyLaterPurchaseLimitAlert();
          if (btn) btn.disabled = false;
          return;
        }

        return addToCart(item.variant_id, item.quantity, item.properties)
          .then(function (res) {
            if (!res.ok) {
              showBuyLaterOutOfStockAlert();
              if (btn) btn.disabled = false;
              return;
            }
            if (isLoggedIn()) {
              sessionStorage.setItem('buy_later_pending_remove', item.added_at);
            } else {
              setLocalItems(getLocalItems().filter(function (i) {
                return i.added_at !== item.added_at;
              }));
            }
            // ページリロードは fetch インターセプターが行う
          });
      })
      .catch(function () {
        alert('カートへの追加に失敗しました');
        if (btn) btn.disabled = false;
      });
  }

  // ─── あとから買うへ保存 ──────────────────────────────────
  function saveToBuyLater(btn) {
    btn.disabled = true;

    var key = btn.dataset.key;
    var variantId = btn.dataset.variantId;
    var quantity = parseInt(btn.dataset.quantity, 10);
    var title = btn.dataset.title;
    var price = parseInt(btn.dataset.price, 10);
    var image = btn.dataset.image || '';
    var handle = btn.dataset.handle || '';
    var type = btn.dataset.type || '';
    var label = btn.dataset.label || '';
    // Shopify Liquid の `line_item.properties | json` は [[key,val],...] 形式で出力される
    var properties = {};
    try {
      var rawProps = JSON.parse(btn.dataset.properties || '[]');
      if (Array.isArray(rawProps)) {
        rawProps.forEach(function (pair) {
          if (Array.isArray(pair) && pair.length >= 2) properties[pair[0]] = pair[1];
        });
      } else if (rawProps && typeof rawProps === 'object') {
        properties = rawProps;
      }
    } catch (_) {}
    var option = {};
    try {
      var optNames = JSON.parse(btn.dataset.optionNames || '[]');
      var optValues = JSON.parse(btn.dataset.optionValues || '[]');
      optNames.forEach(function (name, i) {
        option[name] = optValues[i] !== undefined ? optValues[i] : '';
      });
    } catch (_) {}

    var item = {
      variant_id: variantId,
      quantity: quantity,
      properties: properties,
      title: title,
      price: price,
      handle: handle,
      type: type,
      image: image,
      label: label,
      option: option,
    };

    if (isLoggedIn()) {
      // APIには仕様で定義されたフィールドのみ送信（表示専用フィールドは除外）
      var apiPayload = {
        variant_id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties,
        title: item.title,
        price: item.price,
        handle: item.handle,
        type: item.type,
        image: item.image,
        label: item.label,
        option: item.option,
      };
      apiAdd(apiPayload)
        .then(function (result) {
          if (result.success !== true) {
            if (result.error === 'limit_exceeded') {
              showBuyLaterMaxAlert();
            } else {
              alert('あとで買うリストへの追加に失敗しました。');
            }
            btn.disabled = false;
            return;
          }
          return removeFromCart(key);
          // ページリロードは fetch インターセプターが行う
        })
        .catch(function () {
          alert('あとで買うリストへの追加に失敗しました。');
          btn.disabled = false;
        });
    } else {
      var items = getLocalItems();
      if (items.length >= LIMIT) {
        showBuyLaterMaxAlert();
        btn.disabled = false;
        return;
      }
      item.added_at = new Date().toISOString();
      setLocalItems(items.concat([item]));
      removeFromCart(key);
      // ページリロードは fetch インターセプターが行う
    }
  }

  // ─── ログイン時のマージ ──────────────────────────────────
  function mergeBuyLaterToAccount() {
    if (!isLoggedIn()) return Promise.resolve();
    var guestItems = getLocalItems();
    if (guestItems.length === 0) return Promise.resolve();

    return apiMerge(guestItems)
      .then(function (result) {
        if (result.success) localStorage.removeItem(STORAGE_KEY);
      })
      .catch(function () {});
  }

  // ─── 初期化 ──────────────────────────────────────────────
  function init() {
    // カートに戻す成功後のリロード時に sessionStorage の pending remove を処理する
    var pendingRemoveAt = isLoggedIn()
      ? sessionStorage.getItem('buy_later_pending_remove')
      : null;

    var ready;
    if (pendingRemoveAt) {
      sessionStorage.removeItem('buy_later_pending_remove');
      ready = apiRemove(pendingRemoveAt)
        .catch(function () {})
        .then(function () { return mergeBuyLaterToAccount(); });
    } else {
      ready = mergeBuyLaterToAccount();
    }
    ready.then(function () { return renderList(); });

    document.querySelectorAll('.js-buy-later-save').forEach(function (btn) {
      btn.addEventListener('click', function () { saveToBuyLater(btn); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
